import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <section id="faq" className="py-14 md:py-20 bg-background-50">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
              常见问题
            </h2>
            <p className="text-sm text-foreground-600">
              关于秘密教学，你可能想知道的一切
            </p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item, index) => (
              <div
                key={index}
                className="border border-background-200/70 rounded-lg overflow-hidden transition-all duration-300"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                >
                  <span className="text-sm font-medium text-foreground-950 pr-4">{item.question}</span>
                  <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-300 ${
                    openIndex === index
                      ? 'bg-primary-500 text-background-50 rotate-180'
                      : 'bg-background-200 text-foreground-500'
                  }`}>
                    <i className="ri-arrow-down-s-line text-sm"></i>
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-96' : 'max-h-0'
                  }`}
                >
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}